import { Injectable, signal } from '@angular/core';
import type { SupportTicketType } from '../api/support.service';

export interface SupportEntry {
  screenshot: string | null;
  type: SupportTicketType | null;
}

/**
 * Transient store for the support form pre-fill state (type + optional screenshot)
 * captured before navigating to the support page. Data is consumed once then cleared.
 */
@Injectable({ providedIn: 'root' })
export class SupportStateService {
  private readonly _entry = signal<SupportEntry>({ screenshot: null, type: null });

  set(data: SupportEntry): void {
    this._entry.set(data);
  }

  /** Read the entry and clear it from the store. */
  consume(): SupportEntry {
    const data = this._entry();
    this._entry.set({ screenshot: null, type: null });
    return data;
  }
}
